"use strict";

exports.__esModule = true;
var Constants = {
	INVOICE_STATUS: {
		NEW: 1,
		PAYED: 2
	}
};

exports["default"] = Constants;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/constants.js
 ** module id = 38
 ** module chunks = 2
 **/